
import FeesEditor from '@/app/components/FeesAndCharges/FeesEditor.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { BModal } from 'bootstrap-vue';
import AcoTiersModal from '@/app/components/FeesAndCharges/AcoTiersModal.vue';
import { BankingScheme, FeePaymentType } from 'ah-api-gateways';

@Component({
  components: {
    FeesEditor,
    AcoTiersModal,
  },
})
export default class FeesListView extends Vue {
  $refs!: {
    feesEditor: FeesEditor;
    resetToZeromodal: BModal;
    resetToDefaultModal: BModal;
    mobileFeesEditorModal: BModal;
  };

  @Prop({ default: null }) clientId!: string | null;

  @Prop({ default: null }) clientName!: string | null;

  @Prop({ default: null }) paymentType!: FeePaymentType | null;

  @Prop({ default: false }) inModal!: boolean | string;

  private isFormBusy = false;

  private bankingScheme = BankingScheme.LOCAL;

  get typeLabel() {
    return this.paymentType === 'RECEIPT' ? 'Funding' : 'Payment';
  }

  get partnerName() {
    return this.$theme.val?.name;
  }

  get isStackedView() {
    return this.$mediaQuery.is('smDown');
  }

  get mobileTitle() {
    return this.bankingScheme === BankingScheme.LOCAL ? 'Edit LOCAL rail fees' : 'Edit SWIFT rail fees';
  }

  get isInModal() {
    return this.inModal !== false;
  }

  resetFeesToZero() {
    const confirm = () => {
      this.$refs.feesEditor.setFeesToZero();
    };

    this.$refs.resetToZeromodal.show();
    this.$refs.resetToZeromodal.$once('ok', confirm);
    this.$refs.resetToZeromodal.$once('hidden', () => {
      this.$refs.resetToZeromodal.$off('ok', confirm);
    });
  }

  resetFeesToDefault() {
    const confirm = () => {
      this.$refs.feesEditor.setFeesToDefault();
    };

    this.$refs.resetToDefaultModal.show();
    this.$refs.resetToDefaultModal.$once('ok', confirm);
    this.$refs.resetToDefaultModal.$once('hidden', () => {
      this.$refs.resetToDefaultModal.$off('ok', confirm);
    });
  }

  openMobileModal(bankingScheme: BankingScheme) {
    this.bankingScheme = bankingScheme;
    this.$refs.mobileFeesEditorModal.show();
  }
}
